import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[0.6875rem] font-bold tracking-[0.01em]",
  {
    variants: {
      tone: {
        neutral: "bg-surface-muted text-ink-soft",
        positive: "bg-positive-soft text-positive",
        warning: "bg-warning-soft text-warning",
        danger: "bg-danger-soft text-danger",
        accent: "bg-accent-soft text-accent-ink",
      },
    },
    defaultVariants: {
      tone: "neutral",
    },
  },
);

interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
